import { api } from "@/lib/api";
import {
  Client,
  ClientDtoSchema,
  clientFromDto,
  CreateClient,
  createClientToDto,
} from "@/models";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useToast } from "../use-toast";
import { getClientsQueryOptions } from "./get.hooks";

export function useCreateClient(opts?: {
  onSuccess?: (client: Client) => void;
  onError?: () => void;
}) {
  const queryClient = useQueryClient();
  const { toast } = useToast();
  return useMutation({
    mutationFn: async (client: CreateClient) => {
      const dto = createClientToDto(client);
      const result = await api.post("/api/clients", dto, ClientDtoSchema);
      return clientFromDto(result);
    },
    onSuccess: (client) => {
      queryClient.setQueryData(getClientsQueryOptions.queryKey, (old) => [
        ...(old ?? []),
        client,
      ]);
      toast({
        title: "toast.clientCreated",
        variant: "success",
      });
      opts?.onSuccess?.(client);
    },
    onError: () => {
      toast({
        title: "toast.createClientError",
        variant: "destructive",
      });
      opts?.onError?.();
    },
  });
}
